import { AxiosResponse } from "axios";
import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";

interface IUser {
  id: string | number;
  name: string;
  email?: string;
}

interface IUsersRes {
  items: IUser[],
  totalCount: number,
}

export const usersAPI = {
  getUsersLookup: async (): Promise<AxiosResponse<IUsersRes>> => {
    return await axiosApi.get(
      `users/lookup`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      },
    );
  },
  getUserById: async (id: number) => {
    return await axiosApi.get(
      `users/${id}`
    )
  }
}